import { apiAthenas } from '@/services/api/apiAthenas'
import { History } from '@/types/History'

export async function getDemandHistory(id: string) {
  const { data } = await apiAthenas.get<History[]>(`demands/${id}/history`)

  return data
}
